import React, { useState, useRef } from "react"
import style from "../components/bioMobile.module.scss"

import { AnimatePresence, motion } from "framer-motion"
import scrollTo from "gatsby-plugin-smoothscroll"

export default function BioMobile({ id, color, naam, bio, link, pic, key }) {
  const tekstRef = useRef()
  const [isSelected, setIsSelected] = useState(false)

  return (
    <li
      className={style.listItem}
      id={naam.split(" ")[0]}
      key={id}
      style={{
        backgroundColor: id % 2 ? "#c6e4ee" : "#bdecbd",
        marginTop: isSelected && "9rem",
        transition: "margin-top 1s ease",
      }}
      onMouseOut={() => setIsSelected(!isSelected)}
      onMouseOver={() => {
        setIsSelected(!isSelected)
        scrollTo(`#${naam.split(" ")[0]}`)
      }}
    >
      <h3 className={style.naam}>{naam}</h3>
      <p className={style.arrow}>&#9660;</p>
      <AnimatePresence>
        {isSelected && (
          <motion.div>
            <div
              className={style.tekstWrapper}
              // style={useSpring({
              //   height: `${height}px`,
              //   // height: isSelected ? `${height}px` : "60.4px",
              //   config: { mass: 0.5, tension: 350, friction: 20 },
              // })}
            >
              <p className={style.tekst} ref={tekstRef}>
                {bio}
              </p>
            </div>
            {link.map(weblink => {
              return (
                <a href={`https://${weblink}`} target="_blank" rel="noreferrer">
                  {weblink}
                </a>
              )
            })}
          </motion.div>
        )}
      </AnimatePresence>
      {/* <button onClick={() => setIsSelected(!isSelected)}>
        {isSelected ? "lees minder" : "lees meer"}
      </button> */}
    </li>
  )
}
